import React from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import KnowledgeBase from './components/Templates/KnowledgeBase/KnowledgeBase';
import HomePage from './components/pages/HomePage/HomePage';
import LoginPage from './components/pages/LoginPage/LoginPage';
import CountriesPage from './components/pages/CountriesPage/CountriesPage';
import DynastiesPage from './components/pages/DynastiesPage/DynastiesPage';
import ComponentsPage from './components/pages/ComponentsPage/ComponentsPage';
import BuildingElements from './components/pages/BuildingElements/BuildingElements';
import ProductsPage from './components/pages/ProductsPage/ProductsPage';
import ContextsPage from './components/pages/ContextsPage/ContextsPage';
import CharacteristicsPage from './components/pages/CharacteristcsPage/CharacteristicsPage';
import BuildingTypesPage from './components/pages/BuildingTypesPage/BuildingTypesPage';
import DataTypesPage from './components/pages/DataTypesPage/DataTypesPage';
import ListComponents from './components/pages/Instances/Components/ListComponents/ListComponents';
import EditViewComponent from './components/pages/Instances/Components/EditViewComponent/EditViewComponent';
import CreateComponent from './components/pages/Instances/Components/CreateComponent/CreateComponent';
import CreateElement from './components/pages/Instances/Elements/CreateElement/CreateElement';
import ListElements from './components/pages/Instances/Elements/ListElements/ListElements';
import EditViewElement from './components/pages/Instances/Elements/EditViewElement/EditViewElement';
import ViewBuilding from './components/pages/Buildings/ViewBuilding/ViewBuilding';
import ListProducts from './components/pages/Instances/Products/ListComponents/ListProducts';
import CreateProduct from './components/pages/Instances/Products/CreateProduct/CreateProduct';
import EditViewProduct from './components/pages/Instances/Products/EditViewProduct/EditViewProduct';
import ListContexts from './components/pages/Instances/Contexts/ListContexts/ListContexts';
import EditViewContexts from './components/pages/Instances/Contexts/EditViewContext/EditViewContexts';
import CreateContext from './components/pages/Instances/Contexts/CreateContext/CreateContext';
import CreateEditBuilding from './components/pages/Buildings/CreateEditBuilding/CreateEditBuilding';
import ListBuildings from './components/pages/Instances/Buildings/ListBuildings/ListBuildings';
import CitationsPage from './components/pages/CitationsPage/CitationsPage';
import DocumentTypesPage from './components/pages/DocumentTypesPage/DocumentTypesPage';
import ListCharacteristics from './components/pages/Instances/Characteristics/ListCharacteristics/ListCharacteristics';
import EditViewCharacteristic
  from './components/pages/Instances/Characteristics/EditViewCharacteristic/EditViewCharacteristic';
import CreateCharacteristic
  from './components/pages/Instances/Characteristics/CreateCharacteristic/CreateCharacteristic';
import ListUsers from './components/pages/Users/ListUsers/ListUsers';
import CreateEditUser from './components/pages/Users/CreateEditUser/CreateEditUser';
import LogoutPage from './components/pages/LogoutPage/LogoutPage';
import ScholarsPage from './components/pages/ScholarsPage/ScholarsPage';
import InventionsPage from './components/pages/InventionsPage/InventionsPage';
import MuseumsPage from './components/pages/MuseumsPage/MuseumsPage';

function App() {
  const { config } = window;
  return (
    <BrowserRouter basename={config.basename} forceRefresh={false}>
      <Route path="/" exact>
        <Redirect from="/" to="/home" push />
      </Route>
      <Route path="/">
        <KnowledgeBase>
          <Route path="/home" component={HomePage} />
          <Route path="/countries" component={CountriesPage} />
          <Route path="/dynasties" component={DynastiesPage} />
          <Route path="/building-components" component={ComponentsPage} />
          <Route path="/building-elements" component={BuildingElements} />
          <Route path="/products" component={ProductsPage} />
          <Route path="/contexts" component={ContextsPage} />
          <Route path="/characteristics" component={CharacteristicsPage} />
          <Route path="/building-types" component={BuildingTypesPage} />
          <Route path="/data-types" component={DataTypesPage} />
          <Route path="/sources-citations" component={CitationsPage} />
          <Route path="/documents-types" component={DocumentTypesPage} />
          <Route path="/scholars" component={ScholarsPage} />
          <Route path="/inventions" component={InventionsPage} />
          <Route path="/museums" component={MuseumsPage} />
          <Route path="/login" component={LoginPage} />
          <Route path="/logout" component={LogoutPage} />

          <Route path="/instances/building-components" component={ListComponents} exact />
          <Route path="/instances/building-components/view" component={EditViewComponent} exact />
          <Route path="/instances/building-components/create" component={CreateComponent} exact />
          <Route path="/instances/building-components/edit" component={CreateComponent} exact />

          <Route path="/instances/building-elements" component={ListElements} exact />
          <Route path="/instances/building-elements/view" component={EditViewElement} exact />
          <Route path="/instances/building-elements/create" component={CreateElement} exact />
          <Route path="/instances/building-elements/edit" component={CreateElement} exact />

          <Route path="/instances/building-products" component={ListProducts} exact />
          <Route path="/instances/building-products/view" component={EditViewProduct} exact />
          <Route path="/instances/building-products/create" component={CreateProduct} exact />
          <Route path="/instances/building-products/edit" component={CreateProduct} exact />

          <Route path="/instances/building-contexts" component={ListContexts} exact />
          <Route path="/instances/building-contexts/view" component={EditViewContexts} exact />
          <Route path="/instances/building-contexts/create" component={CreateContext} exact />
          <Route path="/instances/building-contexts/edit" component={CreateContext} exact />

          <Route path="/instances/building-characteristics" component={ListCharacteristics} exact />
          <Route path="/instances/building-characteristics/view" component={EditViewCharacteristic} exact />
          <Route path="/instances/building-characteristics/create" component={CreateCharacteristic} exact />
          <Route path="/instances/building-characteristics/edit" component={CreateCharacteristic} exact />

          <Route path="/buildings/view" component={ViewBuilding} exact />
          <Route path="/buildings/create" component={CreateEditBuilding} exact />
          <Route path="/buildings/edit" component={CreateEditBuilding} exact />
          <Route path="/buildings" component={ListBuildings} exact />


          <Route path="/users" component={ListUsers} exact />
          <Route path="/users/create" component={CreateEditUser} exact />
          <Route path="/users/edit" component={CreateEditUser} exact />
        </KnowledgeBase>
      </Route>
    </BrowserRouter>
  );
}

export default App;
